import { Menu } from "antd";
import { NavLink } from "react-router-dom";
import {
  HomeOutlined,
  LogoutOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  IdcardOutlined,
  ReadOutlined,
  CommentOutlined,
  FileAddOutlined,
  DollarOutlined,
  SettingOutlined,
  MenuOutlined,
  CloseCircleOutlined,
  DollarCircleOutlined,
  SolutionOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import "./MenuList.css";
import { useAtom } from "jotai";
import { userRole } from "../states/userRole";
import { showNavigation } from "../states/showNavigation";
import React from "react";

export default function MenuList({ onItemClick }) {
  const [showNav, setShowNav] = useAtom(showNavigation);
  const [role, setRole] = useAtom(userRole);
  const storedFlags = localStorage.getItem("cre-access-flags");
  const creFlags = storedFlags && storedFlags !== "undefined" ? JSON.parse(storedFlags) : {};

  const canSeeOnlineParents = creFlags?.online_tutor_city === true || creFlags?.online_tutor_assignment === true;

  return (
    <Menu theme="dark" mode="inline" className="menu-bar" onClick={onItemClick}>
      <Menu.Item key="dashboard" icon={<HomeOutlined />}>
        <NavLink to="/home">Dashboard</NavLink>
      </Menu.Item>
      <Menu.Item key="tutors" icon={<IdcardOutlined />}>
        <NavLink to="/tutors">Tutors</NavLink>
      </Menu.Item>
      <Menu.Item key="parents-students" icon={<ReadOutlined />}>
        <NavLink to="/students">Parents/Students</NavLink>
      </Menu.Item>
      {/* {canSeeOnlineParents && (
        <Menu.Item key="online-parents" icon={<ReadOutlined />}>
          <NavLink to="/online-parents">Online Parents</NavLink>
        </Menu.Item>
      )} */}
      {(role === "Superadmin" || canSeeOnlineParents) && (
        <Menu.Item key="online-parents" icon={<ReadOutlined />}>
          <NavLink to="/online-parents">Online Parents</NavLink>
        </Menu.Item>
      )}
      <Menu.SubMenu key="comment" title="Commemt" icon={<CommentOutlined />}>
        <Menu.Item key="feedback" icon={<TeamOutlined />}>
          <NavLink to="/feedback">Feedback</NavLink>
        </Menu.Item>
        <Menu.Item key="need-help" icon={<UsergroupAddOutlined />}>
          <NavLink to="/need-help">Need Help</NavLink>
        </Menu.Item>
        <Menu.Item key="payment-failed" icon={<CloseCircleOutlined />}>
          <NavLink to="/payment-failed">Payment Failed</NavLink>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="recurring-payments" icon={<DollarOutlined />}>
        <NavLink to="/recurring-payments">Recurring Payment </NavLink>
      </Menu.Item>
      <Menu.Item key="add-new-deal" icon={<FileAddOutlined />}>
        <NavLink to="/add-new-deal">Add New Deal</NavLink>
      </Menu.Item>
      <Menu.Item key="job-deals" icon={<SolutionOutlined />}>
        <NavLink to="/job-deals">Jobs Deals</NavLink>
      </Menu.Item>
      <Menu.Item key="job-applications" icon={<SolutionOutlined />}>
        <NavLink to="/job-applications">Job Applications</NavLink>
      </Menu.Item>
      {(role === "Superadmin" || role === "Admin") && (
        <Menu.SubMenu key="subnav1" title="Employees" icon={<TeamOutlined />}>
          <Menu.Item key="cre-team" icon={<TeamOutlined />}>
            <NavLink to="/cre-team">Team</NavLink>
          </Menu.Item>
          <Menu.Item key="create-cre" icon={<UsergroupAddOutlined />}>
            <NavLink to="/create-cre">Create CRE</NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      )}
      {role === "Superadmin" && (
        <Menu.Item key="downloads" icon={<ReadOutlined />}>
          <NavLink to="/donwload-data">Downloads</NavLink>
        </Menu.Item>
      )}
      {role === "Superadmin" && (
        <Menu.Item key="tutor-transfer-approval" icon={<DollarCircleOutlined />}>
          <NavLink to="/tutor-transfer-approval">Tutor Transfer Approval</NavLink>
        </Menu.Item>
      )}
      {role === "Superadmin" && (
        <Menu.SubMenu key="settings" title="Settings" icon={<SettingOutlined />}>
          <Menu.Item key="menu-config" icon={<MenuOutlined />}>
            <NavLink to="/menu-config">Menu Config</NavLink>
          </Menu.Item>
          <Menu.Item key="city-master" icon={<EnvironmentOutlined />}>
            <NavLink to="/city-master">City Master</NavLink>
          </Menu.Item>
          <Menu.Item key="whatsapp-templates" icon={<WhatsAppOutlined />}>
            <NavLink to="/whatsapp-templates">WhatsApp Templates</NavLink>
          </Menu.Item>
          <Menu.Item key="job-templates" icon={<FileTextOutlined />}>
            <NavLink to="/job-templates">Job Templates</NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      )}
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <NavLink
          to="/"
          onClick={() => {
            localStorage.removeItem("homeshiksha-cre-jwt");
            setShowNav(false);
          }}
        >
          LogOut
        </NavLink>
      </Menu.Item>
    </Menu>
  );
}
